
import api from '../services/api'

export default {
  ChangePass(params) {
    return api.post(`users/change_password/`,params)
      .then(response => response.data)
      // .catch(error => {
      //   Promise.reject(error)
      // });
  },

  fetchUser() {
    return api.get(`users/`)
      .then(response => response.data).catch(error => {
        Promise.reject(error)
      });
  },
  fetchUser2(params) {
    return api.get(`users/simple_users/`, params)
      .then(response => response.data).catch(error => {
        Promise.reject(error)
      });

  },
  editUser(id, params) {
    return api.put(`users/${id}/`, params)
      .then(response => response.data).catch(error => {
        Promise.reject(error)
      });
  },
  populateNewUsers(payload) {
    return api.post(`users/populate_user/`, payload)
      .then(response => response.data).catch(error => {
        Promise.reject(error)
      });
  }
}